import React from 'react'
import {
  Element,
  baseChildNodes,
  createElementChild,
  createElementLabel
} from './ElementPlugin'
import styled from 'react-emotion'

const childTypes = ['commentText']

const CommentPlugin = () => {
  return {
    schema: {
      blocks: {
        comment: {
          parent: { object: 'document' },
          nodes: baseChildNodes
            .filter(rule => rule.match.type !== 'elementTitle')
            .concat([
              {
                match: {
                  type: 'commentText'
                },
                min: 1
              }
            ]),
          normalize(editor, { code, node, child, index }) {
            switch (code) {
              case 'child_min_invalid':
                const hasElementLabel =
                  node.getBlocksByType('elementLabel').size > 0
                const hasCommentText =
                  node.getBlocksByType('commentText').size > 0

                if (!hasElementLabel) {
                  editor.insertNodeByKey(
                    node.key,
                    0,
                    createElementLabel(
                      'Please replace this with a question label...'
                    )
                  )
                }

                if (!hasCommentText) {
                  editor.insertNodeByKey(
                    node.key,
                    1,
                    createElementChild(
                      'commentText',
                      'Please replace this with a comment...'
                    )
                  )
                }
                break
              default:
                break
            }
          }
        }
      }
    },
    onConstruct(editor, next) {
      editor.registerElement('comment', {
        labelPrefix: 'cm',
        menu: {
          command: 'convertToComment',
          label: 'Comment',
          icon: 'ion-chatbubble-working',
          type: 'comment'
        },
        childTypes: childTypes
      })
      return next()
    },
    renderNode(props, editor, next) {
      switch (props.node.type) {
        case 'comment':
          return <Comment className={'comment'} {...props} />
        case 'commentText':
          return <CommentText {...props} />
        default:
          return next()
      }
    },
    commands: {
      convertToComment(editor, node, data = {}) {
        editor.convertToElement(node, 'comment', ['commentText'], data)
      }
    }
  }
}

const Comment = props => (
  <Element iconName={'element-comment ion-chatbubble-working'} {...props}>
    {props.children}
  </Element>
)

const CommentText = styled.p`
  margin: 0;
`

export default CommentPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/CommentPlugin.js